import * as actionTypes from "../action-types";
import { put, takeLeading } from 'redux-saga/effects';
import { getAPI } from '../../utils/api-function';
import { get_terms_of_use, get_privacy_policy, get_refund_policy, get_about_us, get_shipping_policy } from '../../utils/api-routes';

function* getTermsOfUse() {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield getAPI(get_terms_of_use);
        console.log("Get Terms Of Use Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_TERMS_OF_USE, payload: data?.result?.description });
        } else {
            yield put({ type: actionTypes.SET_TERMS_OF_USE, payload: '' });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });

    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Terms Of Use Saga Error ::: ", error);
    }
};

function* getPrivacyPolicy() {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield getAPI(get_privacy_policy);
        console.log("Get Privacy Policy Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_PRIVACY_POLICY, payload: data?.result?.description });
        } else {
            yield put({ type: actionTypes.SET_PRIVACY_POLICY, payload: '' });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });

    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Privacy Policy Saga Error ::: ", error);
    }
};

function* getRefundPolicy() {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield getAPI(get_refund_policy);
        console.log("Get Refund Policy Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_REFUND_POLICY, payload: data?.result?.description });
        } else {
            yield put({ type: actionTypes.SET_REFUND_POLICY, payload: '' });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });

    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Refund Policy Saga Error ::: ", error);
    }
};

function* getAboutUs() {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield getAPI(get_about_us);
        console.log("Get About Us Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_ABOUT_US, payload: data?.result?.description });
        } else {
            yield put({ type: actionTypes.SET_ABOUT_US, payload: '' });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });

    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get About Us Saga Error ::: ", error);
    }
};

function* getShippingPolicy() {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield getAPI(get_shipping_policy);
        console.log("Get Shipping Policy Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_SHIPPING_POLICY, payload: data?.result?.description });
        } else {
            yield put({ type: actionTypes.SET_SHIPPING_POLICY, payload: '' });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });

    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Shipping Policy Saga Error ::: ", error);
    }
};

export default function* staticpageSaga() {
    //! Static Page
    yield takeLeading(actionTypes.GET_TERMS_OF_USE, getTermsOfUse);
    yield takeLeading(actionTypes.GET_PRIVACY_POLICY, getPrivacyPolicy);
    yield takeLeading(actionTypes.GET_REFUND_POLICY, getRefundPolicy);
    yield takeLeading(actionTypes.GET_ABOUT_US, getAboutUs);
    yield takeLeading(actionTypes.GET_SHIPPING_POLICY, getShippingPolicy);
};
